var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerformanceConversatrion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17948_121574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8555 3.86929C17.7591 3.64667 17.5993 3.45737 17.396 3.32501C17.1927 3.19265 16.955 3.1231 16.7124 3.12504H3.28809C3.04593 3.12504 2.80897 3.19539 2.60603 3.32753C2.40309 3.45967 2.2429 3.64792 2.14494 3.86939C2.04697 4.09086 2.01544 4.33601 2.05419 4.57506C2.09293 4.81411 2.20028 5.03676 2.36318 5.21595L7.50025 10.8667V16.9572C7.50009 17.1835 7.5614 17.4056 7.67763 17.5998C7.79386 17.794 7.96064 17.953 8.16018 18.0597C8.35971 18.1665 8.5845 18.2171 8.81054 18.2061C9.03658 18.1951 9.25539 18.1229 9.4436 17.9972L11.9436 16.3307C12.115 16.2167 12.2555 16.0621 12.3526 15.8806C12.4498 15.6991 12.5005 15.4964 12.5002 15.2906V10.8667L17.6373 5.21588C17.802 5.03767 17.9104 4.81492 17.9492 4.57544C17.988 4.33596 17.9554 4.09036 17.8555 3.86929Z",
    stroke: "#00D998",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17948_121574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceConversatrion);
export default __webpack_public_path__ + "static/media/performance-conversatrion.7e4021e46b4f0eff90a8e9f62f5c4f28.svg";
export { ForwardRef as ReactComponent };